import type { TFunction } from 'i18next'

import { getDatesLocale } from '@/shared/i18n'

export const getLocalization = (t: TFunction) => ({
	applyText: t('general_apply', { defaultValue: 'Apply' }),
	cancelText: t('general_cancel', { defaultValue: 'Cancel' }),
	backText: t('general_back', { defaultValue: 'Back' }),
	resetText: t('calendar.reset_to_default', {
		defaultValue: 'Reset to default',
	}),
	absoluteDateText: t('calendar.absolute_date', {
		defaultValue: 'Absolute date',
	}),
	customRangePlaceholderText: t('calendar.custom_range_placeholder', {
		defaultValue: 'Custom range: 2d, 3w, 1h...',
	}),
	getDateFnsLocalization() {
		return getDatesLocale()
	},
})
